export default {
  // フッター
  TERMS_OF_SERVICE: "利用規約",
  PRIVACY_POLICY: "プライバシーポリシー",
  COMPANY_INFORMATION: "企業情報",
  MAILORDERLAW_DETAILS: "特定商取引法に関する表示",
  ATAMI_CITY_TOURISM_ASSOCIATION: "熱海市観光協会 (Atami City Tourism Association)",
};
